define('shared/initializer/form/newHouseAdapters/mixins/OrderInfoStorable',[
    'shared/lib/RSVP',
    'shared/util/state',
    'shared/util/state/adapters/order'
], 
function(
    RSVP,
    state,
    orderAdapter
) {

    function Ctor() {

    }

    Ctor.prototype.doBeforeRedirect = function(data) {
        if (!data || !data.Order_id) {
            return RSVP.resolve(data);
        }

        return RSVP.resolve()
            .then(function(){
                return state.adapters.add(orderAdapter);
            })
            .then(function(){
                var promises = [];

                for(var key in data) {
                    if (!data.hasOwnProperty(key)) {
                        return;
                    }
                    promises.push(state.push('order.' +  key, data[key]));
                }
                
                return RSVP.all(promises);
            })
            .then(function(){
                return data;
            });
    };

    return Ctor;
});
